import React from "react";
import "./WhyJoinUs.css";

export default function WhyJoinUs({ currentLanguage = "en" }) {
  const isFrench = currentLanguage === "fr";

  // ================= ENGLISH DATA =================
  const dataEN = {
    title: "WHY JOIN PESTEL & PARTNERS",
    subtitle:
      "Discover the benefits that make us a preferred employer in the accounting and consulting industry",
    benefits: [
      {
        icon: "/assets/images/Career/benefit-growth.png",
        title: "Career Growth",
        desc:
          "We offer structured career paths, mentorship, and opportunities to grow professionally and personally.",
      },
      {
        icon: "/assets/images/Career/benefit-team.png",
        title: "Collaborative Culture",
        desc:
          "Work in a supportive, inclusive environment that values teamwork and shared success.",
      },
      {
        icon: "/assets/images/Career/benefit-learning.png",
        title: "Learning Opportunities",
        desc:
          "Access continuous learning, training programs, and exposure to diverse client engagements.",
      },
      {
        icon: "/assets/images/Career/benefit-balance.png",
        title: "Work-Life Balance",
        desc:
          "We promote flexibility and well-being to help you maintain a healthy work-life balance.",
      },
    ],
  };

  // ================= FRENCH DATA =================
  const dataFR = {
    title: "POURQUOI REJOINDRE PESTEL & PARTNERS",
    subtitle:
      "Découvrez les avantages qui font de nous un employeur de choix dans le secteur de la comptabilité et du conseil",
    benefits: [
      {
        icon: "/assets/images/Career/benefit-growth.png",
        title: "Évolution de carrière",
        desc:
          "Nous proposons des parcours de carrière structurés, du mentorat et des opportunités de développement professionnel.",
      },
      {
        icon: "/assets/images/Career/benefit-team.png",
        title: "Culture collaborative",
        desc:
          "Évoluez dans un environnement inclusif et bienveillant qui valorise le travail d’équipe.",
      },
      {
        icon: "/assets/images/Career/benefit-learning.png",
        title: "Opportunités d’apprentissage",
        desc:
          "Bénéficiez de formations continues et d’une exposition à des missions clients variées.",
      },
      {
        icon: "/assets/images/Career/benefit-balance.png",
        title: "Équilibre vie professionnelle et personnelle",
        desc:
          "Nous encourageons la flexibilité et le bien-être pour préserver un équilibre sain.",
      },
    ],
  };

  // ================= SELECT LANGUAGE =================
  const data = isFrench ? dataFR : dataEN;
  const { title, subtitle, benefits } = data;

  return (
    <div className="whyjoin-wrapper section">
      {/* Heading */}
      <h2 className="whyjoin-title">{title}</h2>
      <p className="whyjoin-subtitle">{subtitle}</p>

      {/* Cards */}
      <div className="row mt-4">
        {benefits.map((item, idx) => (
          <div
            className="col-lg-3 col-md-6 col-sm-12 mb-4 padding-mobile"
            key={idx}
          >
            <div className="whyjoin-card d-flex align-items-start">
              <div className="whyjoin-icon">
                <img src={item.icon} alt={item.title} />
              </div>

              <div className="whyjoin-text">
                <h5 className="whyjoin-card-title">{item.title}</h5>
                <p className="whyjoin-card-desc">{item.desc}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
